import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import './MedicationForms.css';
import { fetchUserEdgeData, saveMedication, fetchFormDataMedication } from '../../../services/hih/Service';
import axios from "axios";
import Select from 'react-select';


const MedicationForms = ({ closeModal, callHomeBasedServicesHistory, aiBupaServiceRecommendations, memberBasicInfo, getAiBupaServiceRecommendations, handleFamilyMemberProfileClick }) => {

    const userId = memberBasicInfo.userId;

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [disabledButton, setDisabledButton] = useState(true);
    const [cityList, setCityList] = useState([]);
    const [partnerList, setPartnerList] = useState([]);
    const [pharmacyList, setPharmacyList] = useState([]);

    let aiBupaMedicines = "";
    if (aiBupaServiceRecommendations[0]?.medicines) {
        if (aiBupaServiceRecommendations[0]?.medicines?.length > 0) {
            aiBupaServiceRecommendations[0]?.medicines.map((item, index) => {
                aiBupaMedicines += item.serviceDesc + " - " + item.servicelineItemQuantity + "\n";
            })

        }
    }


    const [formData, setFormData] = useState({
        userId: userId,
        selectedServiceRecord: { recordId: "", serviceName: "", serviceType: "", serviceRequestType: "" },
        membership: '',
        name: '',
        mobileNumber: '',
        partnerClinic: '',
        remarks: '',
        medications: aiBupaMedicines,
        pharmacy: '',
        deliveryRefill: '',
        city: '',
        district: '',
        deductible: '',
        cityId: '',
        recommendationIds: (aiBupaMedicines != "") ? aiBupaServiceRecommendations
            .flatMap(item => item.medicines.map(med => med.recommendationId))
            .join(",") : "",
        source: (aiBupaMedicines != "") ? "aibupa" : ""
    });

    useEffect(() => {
        fetchUserData();
        dropdownData();
    }, [])


    const fetchUserData = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        setDisabledButton(true);
        await fetchUserEdgeData(userId)
            .then((response) => {
                if (response.data.code === 200) {
                    setFormData((prev) => ({ ...prev, membership: memberBasicInfo.membershipNumber, name: memberBasicInfo.memberName, mobileNumber: memberBasicInfo.mobile, nationality: memberBasicInfo.nationality }));
                    setDisabledButton(false);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }

    /*const fetchUserData = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        setDisabledButton(true);
        await fetchUserProfile(userId, '')
            .then((response) => {
                if (response.data.code === 200) {
                    setFormData((prev) => ({ ...prev, membership: response.data.data.info.membershipNumber, name: response.data.data.info.memberName, mobileNumber: response.data.data.info.mobile, city: response.data.data.info.city }));
                    setDisabledButton(false);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }*/


    const handleChange = async (e) => {
        const { name, value } = e.target;

        // if (name === "deductible") {
        //     if (!/^\d*\.?\d*$/.test(value)) {
        //         return false;
        //     }
        // }

        setFormData({
            ...formData,
            [name]: value,
        });

        setError('');
    };

    const validateForm = () => {
        const mandatoryFields = ['membership', 'name', 'mobileNumber', 'partnerClinic', 'medications', 'pharmacy', 'deliveryRefill', 'city'];

        for (let field of mandatoryFields) {
            if ((field === 'city')) {
                if (formData[field] == "") {
                    setError('Enter all mandatory fields');
                    return false;
                }
            } else if (!formData[field].trim()) {
                setError('Enter all mandatory fields');
                return false;
            }
        }

        return true;
    };

    const handleChangeCity = (selectedOption) => {
        setFormData({
            ...formData,
            ['city']: selectedOption.label,
            ['cityId']: selectedOption.value,
        });
    };

    const handleSubmit = async (event) => {

        event.preventDefault();
        if (validateForm()) {
            const request = axios.CancelToken.source();
            let ct = {
                cancelToken: request.token
            }
            setDisabledButton(true);

            await saveMedication(formData)
                .then((response) => {
                    if (response.data.code === 200) {
                        setError('');
                        getAiBupaServiceRecommendations(memberBasicInfo.membershipNumber);
                        handleFamilyMemberProfileClick(memberBasicInfo.membershipNumber);
                        setMessage(response.data.data.message);
                        //callHomeBasedServicesHistory();
                        setTimeout(() => {
                            closeModal();
                        }, 1000);
                    } else {
                        setMessage('');
                        setError(response.data.data.message);
                    }
                    setDisabledButton(false);
                }).catch(function (error) {
                    console.log(error);
                });
            return () => request.cancel();
        }
    }


    const dropdownData = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchFormDataMedication()
            .then((response) => {
                if (response.data.code === 200) {
                    setCityList(response.data.data.city);
                    setPharmacyList(response.data.data.pharmacy);
                    setPartnerList(response.data.data.partner);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }

    return (
        <>

            <div className='col-md-12'>
                <div className='card card-task-appoint'>
                    <div className='card-body'>
                        <div className='card-text'></div>
                        <form id="medicationForm" onSubmit={handleSubmit}>

                            <div className='row'>

                                <div className='col-md-6 mb-3'>
                                    <div className="row">
                                        <div className='col-md-6 mb-1'>
                                            <label className="form-label">Membership</label>
                                            <h4 name="membership">{formData['membership']}</h4>
                                        </div>

                                        <div className='col-md-6 mb-1'>
                                            <label className="form-label">Name</label>
                                            <h4 name="name">{formData['name']}</h4>
                                        </div>

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label">Mobile Number
                                                <span className='text-danger'>*</span></label>
                                            <input type="text" name="mobileNumber" className='form-control control-input-ui' value={formData['mobileNumber']} onChange={handleChange} />
                                        </div>

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label"> Partner Clinic
                                                <span className='text-danger'>*</span></label>
                                            <select className="form-select select-input-ui" name="partnerClinic" id="partnerClinic" value={formData['partnerClinic']} onChange={handleChange} >
                                                <option value="">-- Select Partner Clinic --</option>
                                                {partnerList.map(option => (
                                                    <option key={option.id} value={option.id}>{option.partnerName}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label">Pharmacy
                                                <span className='text-danger'>*</span></label>
                                            <select className="form-select select-input-ui" name="pharmacy" id="pharmacy" value={formData['pharmacy']} onChange={handleChange} >
                                                <option value="">-- Select Pharmacy --</option>
                                                {pharmacyList.map(option => (
                                                    <option key={option.id} value={option.id}>{option.pharmacyName}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label"> Delivery/Refill
                                                <span className='text-danger'>*</span></label>
                                            <select className="form-select select-input-ui" name="deliveryRefill" id="deliveryRefill" value={formData['deliveryRefill']} onChange={handleChange} >
                                                <option value="">-- Select Delivery/Refill --</option>
                                                <option value="Delivery">Delivery</option>
                                                <option value="Refill">Refill</option>
                                            </select>
                                        </div>

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label">City
                                                <span className='text-danger'>*</span>
                                            </label>
                                            {/* <select className="form-select select-input-ui" name="city" id="city" value={formData['city']} onChange={handleChange} >
                                <option value="">-- Select City --</option>
                                {cityList.map(option => (
                                    <option key={option.id} value={option.cityName}>{option.cityName}</option>
                                ))}
                            </select> */}

                                            <Select
                                                value={cityList.find(option => option.label === formData.city) || null}
                                                onChange={handleChangeCity}
                                                options={cityList}
                                                isSearchable={true}
                                                placeholder="Select City"
                                                className="form-control select-input-ui select-input-ui-select"
                                            />
                                        </div>

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label">District</label>
                                            <input type="text" name="district" className='form-control control-input-ui' value={formData['district']} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md mb-3 '>
                                    <div className="row">

                                        <div className='col-md-12 mb-3'>
                                            <label className="form-label">Medications
                                                <span className='text-danger'>*</span></label>
                                            <textarea type="text" name="medications" className='form-control control-input-ui' style={{ height: "210px" }} rows="7" value={formData['medications']} onChange={handleChange}></textarea>
                                        </div>

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label"> Deductible</label>
                                            <input type="text" name="deductible" className='form-control control-input-ui' value={formData['deductible']} onChange={handleChange} />
                                        </div>

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label">Remarks</label>
                                            <input type="text" name="remarks" className='form-control control-input-ui' value={formData['remarks']} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-12 text-center'>
                                    <div className={`${error != "" ? "errorDiv" : "hide"}`}>{error}</div>
                                    <div className={`${message != "" ? "messageDiv" : "hide"}`}>{message}</div>
                                    <Button variant="primary" type="submit" className="btn btn-primary save-btn me-3" disabled={disabledButton}>Save Medication Request</Button>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>



        </>
    )
}

export default MedicationForms;